import * as React from 'react'

/**
 * @description MoneyCoins icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { MoneyCoins } from '@sravni/design-system-icons'
 *
 * <MoneyCoins />
 * ```
 */
export const MoneyCoins = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="MoneyCoins" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.614 7.798a1.458 1.458 0 0 0-2.062 0l-.442-.442.442.442c-.57.57-.57 1.493 0 2.063l-.442.442.442-.442a1.458 1.458 0 0 0 2.063-2.063l.441-.442-.441.442Zm-2.946-.884a2.708 2.708 0 1 1 3.83 3.83 2.708 2.708 0 0 1-3.83-3.83Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.042 5.08a2.291 2.291 0 0 1 2.291-2.29h12.5a2.291 2.291 0 0 1 2.292 2.29v6.57a.625.625 0 1 1-1.25 0V5.08c0-.575-.466-1.04-1.042-1.04h-12.5c-.575 0-1.042.465-1.042 1.04v7.5c0 .576.467 1.042 1.042 1.042h6.884a.625.625 0 1 1 0 1.25H3.333a2.291 2.291 0 0 1-2.292-2.291v-7.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.542 11.75c0-.345.28-.625.625-.625h1.666a.625.625 0 1 1 0 1.25H4.166a.625.625 0 0 1-.625-.625ZM12.708 5.914c0-.345.28-.625.625-.625H15a.625.625 0 1 1 0 1.25h-1.667a.625.625 0 0 1-.625-.625ZM13.436 12.446a.625.625 0 0 1-.605.644 2.27 2.27 0 1 0 2.123 3.221.625.625 0 0 1 1.133.528 3.516 3.516 0 0 1-3.188 2.04 3.52 3.52 0 0 1-.107-7.04c.346-.01.634.262.644.607Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.434 11.41a2.275 2.275 0 1 0 0 4.55 2.275 2.275 0 0 0 0-4.55Zm-3.524 2.274a3.524 3.524 0 1 1 7.049.001 3.524 3.524 0 0 1-7.05 0Z"
      fill="currentColor"
    />
  </svg>
))
